<template>
    <div>
        <v-row class="mx-0" :dense="$vuetify.display.smAndDown">
            <report-ticket-status-dashboard></report-ticket-status-dashboard>
            <v-col order="1" cols="12" md="8">
                <div class="helpical-cards h-100">
                    <p class="text-small font-weight-medium text-primary">
                        <i class="icon icon-Reportsmallicon icon-lg me-2"><span class="icon path1"></span><span class="icon path2"></span><span class="icon path3"></span><span class="icon path4"></span><span class="icon path5"></span></i>گزارشات سامانه (یک سال گذشته)
                    </p>
                    <v-tabs v-model="reportTab" class="my-1" v-if="(auth.user.full_admin || auth.user.branch_admin || auth.user.department_admin) || (system.license.features.ticket_sla && auth.user.employee)" color="secondary">
                        <v-tab value="ticketFrequency">فراوانی تیکت‌ها</v-tab>
                        <v-tab value="serviceTicket" v-if="auth.user.full_admin || auth.user.branch_admin || auth.user.department_admin">تیکت سرویس‌ها/محصولات</v-tab>
                        <v-tab value="slaTicket" v-if="system.license.features.ticket_sla && auth.user.employee">قوانین SLA</v-tab>
                    </v-tabs>
                    <v-tabs-window v-model="reportTab">
                        <v-tabs-window-item value="ticketFrequency">
                            <report-ticket-frequency :showTitle="false"></report-ticket-frequency>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="serviceTicket">
                            <report-service-ticket :showTitle="false"></report-service-ticket>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="slaTicket">
                            <report-sla-ticket :showTitle="false"></report-sla-ticket>
                        </v-tabs-window-item>
                    </v-tabs-window>
                </div>
            </v-col>
            <v-col order="1" order-md="0" cols="12" sm="6" md="4" v-if="auth.user.employee">
                <div class="helpical-cards h-100">
                    <todos></todos>
                </div>
            </v-col>
            <v-col order="1" :order-md="!auth.user.employee ? '0' : '1'" cols="12" sm="6" md="4">
                <div class="helpical-cards h-100">
                    <p class="text-small font-weight-medium text-primary">
                        <i class="icon icon-Announcementsmallicon icon-lg me-2"><span class="icon path1"></span><span class="icon path2"></span><span class="icon path3"></span><span class="icon path4"></span><span class="icon path5"></span></i>
                        {{ hasEventsPermission ? 'اطلاعیه / رویداد' : 'اطلاعیه' }}
                    </p>
                    <v-tabs v-model="eventAnnouncementTab" class="my-1" v-if="hasEventsPermission" color="secondary">
                        <v-tab value="announcements">اطلاعیه‌ها</v-tab>
                        <v-tab value="events" v-if="hasEventsPermission">رویدادهای امروز مشتریان</v-tab>
                    </v-tabs>
                    <v-tabs-window v-model="eventAnnouncementTab">
                        <v-tabs-window-item value="announcements">
                            <announcements-dashboard></announcements-dashboard>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="events">
                            <events-dashboard></events-dashboard>
                        </v-tabs-window-item>
                    </v-tabs-window>
                </div>
            </v-col>
            <v-col order="1" sm="6" :md="auth.user.employee ? '4' : '6'" cols="12">
                <div class="helpical-cards h-100">
                    <report-ticket-status></report-ticket-status>
                </div>
            </v-col>
            <v-col order="1" sm="6" md="4" cols="12" v-if="auth.user.employee">
                <div class="helpical-cards h-100">
                    <report-satisfaction-ticket></report-satisfaction-ticket>
                </div>
            </v-col>
            <v-col order="1" cols="6" class="d-md-block d-none" v-if="!auth.user.employee">
                <div class="helpical-cards h-100">
                    <report-importance-ticket :showTitle="false"></report-importance-ticket>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
defineOptions({
    title: "داشبورد",
})

const rbac = useRbac();
const system = useSystemStore();
const auth = useAuthStore();
const reportTab = ref('ticketFrequency');
const eventAnnouncementTab = ref('announcements');
const hasEventsPermission = computed(() => {
    return (rbac.can('manage customers') || rbac.can('view customer information')) && system.license.features.customer_event;
})
</script>
